import React from 'react';
import BopisScheduler, { GOTHAM } from './BopisScheduler';

// Gotham FC BOPIS — match-day store scheduler (gotham_bopis_scheduler.py).
export default function GothamBOPIS() {
  return <BopisScheduler team={GOTHAM} />;
}
